import { supabase } from "@/lib/supabase/client";

export type ContactFormState = {
  success: boolean;
  message: string;
};

const allowedCategories = ["Allgemeines", "Probetraining", "Mitgliedschaft"] as const;
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export async function submitContactForm(formData: FormData): Promise<ContactFormState> {
  try {
    const categoryValue = (formData.get("category") as string) || "Allgemeines";
    const firstName = (formData.get("firstName") as string)?.trim() || "";
    const lastName = (formData.get("lastName") as string)?.trim() || "";
    const email = (formData.get("email") as string)?.trim() || "";
    const phone = ((formData.get("phone") as string) || "").trim() || null;
    const message = ((formData.get("message") as string) || "").trim() || null;
    const privacyAccepted = formData.get("privacy") === "yes";

    if (!firstName || !lastName || !email) {
      return { success: false, message: "Bitte Vorname, Nachname und E-Mail ausfüllen." };
    }

    if (!emailPattern.test(email)) {
      return { success: false, message: "Bitte eine gültige E-Mail-Adresse eingeben." };
    }

    if (!privacyAccepted) {
      return { success: false, message: "Bitte stimmen Sie den Datenschutzbestimmungen zu." };
    }

    if (!allowedCategories.includes(categoryValue as (typeof allowedCategories)[number])) {
      return { success: false, message: "Bitte eine Kategorie auswählen." };
    }

    const { error } = await supabase.from("contact_inquiries").insert({
      category: categoryValue,
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      message,
      status: "Offen",
    });

    if (error) {
      console.error("Supabase insert error:", error);
      return { success: false, message: "Fehler beim Senden der Anfrage." };
    }

    return { success: true, message: "Deine Anfrage wurde erfolgreich gesendet!" };
  } catch (error) {
    console.error("Error submitting contact form:", error);
    return { success: false, message: "Netzwerkfehler. Bitte versuchen Sie es später erneut." };
  }
}
